import LogoTile from "./LogoTile";
import VsChip from "./VsChip";

interface VsLockupProps {
  competitorLogo: { url: string; alt: string };
  size: "sm" | "md" | "lg";
}

/**
 * "Competitor vs Nowadays" logo pair.
 * @param props - the competitor logo and tile size
 * @returns the lockup
 */
export default function VsLockup({ competitorLogo, size }: VsLockupProps) {
  return (
    <div className={`flex items-center ${size === "lg" ? "gap-4 md:gap-6" : "gap-3"}`}>
      <LogoTile logo={competitorLogo} size={size} />
      <VsChip />
      <LogoTile size={size} />
    </div>
  );
}
